"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var HeartFilledSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M9.5,5.69562501 C9.69106038,5.40364828 9.9134022,5.13537471 10.1670254,4.8908043 C11.5412665,3.65986268 13.6543841,3.70463667 14.9748737,5.02512627 C16.3417088,6.39196129 16.3417088,8.60803871 14.9748737,9.97487373 C14.0636504,10.8860971 12.2386925,12.5611392 9.5,15 C6.76130752,12.5611392 4.93634961,10.8860971 4.02512627,9.97487373 C2.65829124,8.60803871 2.65829124,6.39196129 4.02512627,5.02512627 C5.34561586,3.70463667 7.45873351,3.65986268 8.83297456,4.8908043 C9.17940176,5.20728429 9.40174357,5.47555786 9.5,5.69562501 Z" })));
};
HeartFilledSmall.displayName = 'HeartFilledSmall';
exports.default = HeartFilledSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=HeartFilledSmall.js.map